export default [
  {
    text: 'payment.logs.payment',
    value: 'payment',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.provider',
    value: 'provider',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.venue',
    value: 'venue',
    default: true,
    align: 'left',
    sortable: true,
    type: 'slot',
  },
  {
    text: 'payment.logs.messageType',
    value: 'messageType',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.httpMethod',
    value: 'httpMethod',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.httpStatusCode',
    value: 'httpStatusCode',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.url',
    value: 'url',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.endpoint',
    value: 'endpoint',
    default: true,
    align: 'left',
    sortable: true,
  },
  {
    text: 'payment.logs.result',
    value: 'success',
    default: true,
    type: 'slot',
  },
  {
    text: 'payment.logs.createdAt',
    value: 'createdAt',
    default: true,
    align: 'left',
    sortable: true,
    type: 'slot',
  },
  {
    text: 'payment.logs.updatedAt',
    value: 'updatedAt',
    default: true,
    align: 'left',
    sortable: true,
    type: 'slot',
  },
  {
    text: 'payment.logs.expiresAt',
    value: 'expiresAt',
    default: true,
    align: 'left',
    sortable: true,
    type: 'slot',
  },
  {
    text: '',
    value: 'actions',
    default: true,
    align: 'left',
    sortable: false,
    type: 'slot',
    virtual: true,
  },
];
